module.exports = __webpack_public_path__ + "img/other.62150d32.svg";